"use client"
/* */
const fileCard = "flow--file-card";
const link = "flow--file-card--link";
const text = "flow--file-card--text";
const title = "flow--file-card--title";
const subTitle = "flow--file-card--sub-title";
const deleteButton = "flow--file-card--delete-button";
const styles = {
	fileCard: fileCard,
	link: link,
	text: text,
	title: title,
	subTitle: subTitle,
	deleteButton: deleteButton
};

export { styles as default, deleteButton, fileCard, link, subTitle, text, title };
//# sourceMappingURL=FileCard.module.scss.mjs.map
